export class GotVideoByIdEvent extends Event {

  video: any

  constructor (video: any) {
    super('gotVideoById')
    this.video = video
  }
}
